import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { Store } from '@ngxs/store';

import { Exception } from '../models';
import { IRequestsNestedState } from '../../ngxs/interfaces/requests.interface';
import {
  DeleteExceptionAction,
  LoadExceptionsAction,
  SaveExceptionAction,
} from '../../ngxs/exception/exception.actions';
import {
  ExceptionGetterState
} from '../../ngxs/exception';

import { ApplicationService } from './application.service';

@Injectable({
  providedIn: 'root',
})
export class ExceptionService {
  exceptions$: Observable<Exception<any>[]> = this.store.select(ExceptionGetterState.getExceptions)
  exceptionGetRequestState$: Observable<IRequestsNestedState> = this.store.select(ExceptionGetterState.getExceptionGetRequestState)
  saveExceptionPostRequestState$: Observable<IRequestsNestedState> = this.store.select(ExceptionGetterState.getSaveExceptionPostRequestState)
  deleteExceptionPostRequestState$: Observable<IRequestsNestedState> = this.store.select(ExceptionGetterState.getDeleteExceptionPostRequestState)

  constructor(
    private store: Store,
    private applicationService: ApplicationService,
  ) {
    this.exceptionGetRequestState$.subscribe(({ loading }) => {
      this.applicationService.shownAppSpinner$.next(loading);
    });
  }

  loadExceptions() {
    this.store.dispatch(new LoadExceptionsAction());
  }

  saveException(exception: any) {
    this.store.dispatch(new SaveExceptionAction(
      this.getParsedExceptionFormValue(exception),
    ));
  }

  deleteException(exceptionId: number) {
    this.store.dispatch(new DeleteExceptionAction(exceptionId));
  }

  private getParsedExceptionFormValue(exceptionFormValue: any): Exception<any> {
    const { alertMobileNumber, ...exception } = exceptionFormValue;

    return {
      ...exception,
      ...(
        alertMobileNumber?.length
          ? { alertMobileNumber: alertMobileNumber.join(';').replace(/\s/g, '', true) }
          : {}
      ),
    };
  }
}
